import { apiRequest } from "../util/apiUtils";

export const verifyAuthToken = async (payload) => {
  try {
    const res = await apiRequest("post", `verify-token`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const tokenRefresh = async (payload) => {
  try {
    const res = await apiRequest("post", `refresh-token`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
